import { decode } from 'js-base64'
import { storeToRefs } from 'pinia'
import { getCurrentInstance, onMounted } from 'vue'

import { useFetch, useRuntimeConfig } from '#app'
import { commonApi } from '~/api/common'
import { useSiteConfigStore } from '~/stores/siteConfig'
import { storage } from '@/utils/storage'

export const useSite = () => {
  const { apiUrl, clientId, appSecret, intranet } = useRuntimeConfig().public
  const store = useSiteConfigStore()

  // 根據環境決定 API base URL
  const baseUrl = import.meta.server && intranet === '1' ? 'http://frontend-api-v2.default.svc.cluster.local' : apiUrl

  // 從 commonApi 取得 API 配置
  const apiConfig = commonApi.getConfig({ appSecret })
  const apiPath = apiConfig.url.replace(':clientId', clientId)

  // 使用 useFetch 自動執行（SSR 友善）
  const { refresh } = useFetch(`${baseUrl}/${apiPath}`, {
    key: 'site-config',
    dedupe: 'defer', // 如果有相同 key 請求進行中，等待它完成而不是發新請求
    query: apiConfig.params,
    getCachedData(key, nuxtApp) {
      return nuxtApp.payload.data[key] || nuxtApp.static.data[key]
    },
    onResponse({ response }) {
      if (response._data?.config) {
        const config = JSON.parse(decode(response._data.config))
        store.setSiteConfig(config)
      }
    },
    onResponseError({ error: err }) {
      console.error('[useSite] fetchSiteConfig API error:', err)
      store.setSiteConfig({})
    },
  })

  // Client 端 mounted 後存儲 siteConfig 到 localStorage
  // 只有在組件上下文中才註冊 onMounted，避免在 plugin/middleware 中調用時出現警告
  if (getCurrentInstance()) {
    onMounted(() => {
      if (store.siteConfig) {
        storage.set('site-config', store.siteConfig)
      }
    })
  }

  // 直接返回 store 的所有 refs
  return {
    ...storeToRefs(store),
    fetchSiteConfig: refresh,
  }
}
